import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  wrapper: {
    textAlign: 'center',
    marginBottom: '15px',
  },
  image: {
    width: '110px',
    height: '110px',
    border: '1px solid #cccccc',
    padding: '10px',
    margin: '5px 0',
    fontWeight: 'bold',
  },
  description: {
    textTransform: 'uppercase',
    margin: '0',
  },
}));

const Image = ({ positionDescription, type, image }) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <p className={classes.description}>{type}</p>
      <img src={image} alt={positionDescription} className={classes.image} />
      <p className={classes.description}>{positionDescription}</p>
    </div>
  );
};

export default Image;
